import { ServiceStepData } from "@/components/services/ServiceStepCard";

export const personaSteps: ServiceStepData[] = [
  {
    title: "Consultation",
    description:
      "A brief phone call to answer your questions and confirm your laundromat has the minimal space and electrical capacity required.",
    image1: "/springs.webp",
    image2: "/lights.webp",
  },
  {
    title: "Supplying",
    description:
      "Once you have your Georgia Lottery COAM Class B license, you can browse and choose the best machines for your business. Are you patrons more inclined to use traditional skill machines? Modern arcade games? Competitive sports simulators? We carry the most popular games on the market, and one of our technicians will be happy to help you select the perfect model.",
    image1: "/springs.webp",
    image2: "/lights.webp",
  },
  {
    title: "License Approval",
    description:
      "Getting your GA Lottery COAM Location Class B License is a hassle. Don't want to deal with the stress of finding rules and regulations by yourself? No need to—our website has all the information conveniently linked for your ease of browsing, to ensure you're equipped with the proper documentation and fill out your application accurately for speedy approval.",
    image1: "/lights.webp",
    image2: "/springs.webp",
  },
  {
    title: "Set-Up",
    description:
      "Once you've chosen your COAM, our team of technicians will carefully deliver your machine. This includes an expert set-up, quality-assurance check, and expert advice if you have questions or concerns. Our primary goal is ensuring your machine is operating perfectly and guests have a place to enjoy game play. We offer 24/7 service so you can schedule a time that works best for your business.",
    image1: "/springs.webp",
    image2: "/lights.webp",
  },
  {
    title: "Continuing Support",
    description:
      "We believe in long-term partnerships. Our support doesn't end after installation. We provide ongoing maintenance, software updates, and performance monitoring to ensure your machines remain profitable and compliant with all regulations.",
    image1: "/lights.webp",
    image2: "/springs.webp",
  },
];

export const personaDesktopSnakePath =
  "M 50 0 L 50 5 L 10 5 L 10 32 L 95 32 L 95 65 L 15 65 L 15 100 L 95 100 L 95 135 L 15 135 L 15 150";

// Mobile snake paths for each step
export const personaMobileSnakePaths = [
  "M 50 5 L 50 30 L 15 30 L 15 100", // 1. Left (Consultation)
  "M 15 5 L 15 30 L 85 30 L 85 100", // 2. Right (Supplying)
  "M 85 5 L 85 30 L 15 30 L 15 100", // 3. Left (License Approval)
  "M 15 5 L 15 30 L 85 30 L 85 100", // 4. Right (Set-Up)
  "M 85 5 L 85 30 L 15 30 L 15 100", // 5. Left (Continuing Support)
];

// Scroll thresholds for 5 items
export const personaScrollThresholds = [0.1, 0.3, 0.5, 0.7, 0.9];
